import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function SecureImage({ photoId, className, alt = "Progress photo" }) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api.get(`/photos/${photoId}/file`, { responseType: "blob" })
      .then(({ data }) => { url = URL.createObjectURL(data); setSrc(url); })
      .catch(() => setSrc(""));
    return () => url && URL.revokeObjectURL(url);
  }, [photoId]);
  if (src === null) return <div className={`${className} bg-[#1F293D] animate-pulse`} />;
  if (!src) return <div className={`${className} bg-[#1F293D] grid place-items-center text-xs text-slate-500`}>Unavailable</div>;
  return <img src={src} alt={alt} className={className} data-testid={`secure-photo-${photoId}`} />;
}
